import React, { useState } from "react";
import { useEffect } from "react";
import * as fatchSet from "../../api/api";
import { useNavigate, useParams } from "react-router-dom";
import { getParam, getParam_google, tokenSave } from "js/function";
import { LoadingBox } from "component/basic/popup";

const Social = (props) => {
    const navigate = useNavigate();
    const param = useParams();
    const type = param.type;

    useEffect(() => {
        if(type){
            let formData = new FormData();
            if(type == "google"){
                formData.append("token", getParam("code"));
            }
            if(type == "apple"){
                formData.append("code", getParam("code"));
            }
            if(type == "naver"){
                formData.append("token", getParam("code"));
            }
            if(type == "kakao"){
                formData.append("token", getParam("code"));
            }

            fatchSet.FatchApi({
                type:"POST",
                formDataItem: formData,
                url: `/${type}/login${localStorage.getItem("token") ? "/connect" : ""}`,
                loginType: localStorage.getItem("token") ? "login" : null,
                success: (data) => {
                    if(localStorage.getItem("token")){
                        sessionStorage.setItem("snsType",type);
                        navigate("/mypage/profile");
                    }else{
                        if(data.data.type == "login"){
                            localStorage.setItem("token",data?.data?.token?.access_token);
                            localStorage.setItem("refresh_token",data?.data?.token.refresh_token);

                            tokenSave(data?.data?.token?.access_token);

                            window.logIn();

                            setTimeout(() => {
                                if(sessionStorage.getItem("setUrl")){
                                    let reUrl = sessionStorage.getItem("setUrl");
                                    sessionStorage.removeItem("setUrl");
                                    navigate(reUrl);
                                }else{
                                    navigate(`/`);
                                }
                            }, 100);
                        }else{
                            sessionStorage.setItem("token",data?.data?.token?.access_token);
                            sessionStorage.setItem("refresh_token",data?.data?.token?.refresh_token);

                            navigate(`/`);
                            setTimeout(() => {
                                window.joinPopupOpen("sns");
                            }, 500);
                        }
                    }
                },
                err: (data) => {
                    if(data.data || data.alert){
                        window.errPopupOpen(data);
                        if(localStorage.getItem("token")){
                            navigate("/mypage/profile");
                        }else{
                            navigate("/");
                        }
                    }
                }
            })
        }
    }, []);

    return (
        <div className="pageSizing">
            <LoadingBox openType={true}/>
        </div>
    );
};

export default Social;